import { z } from 'zod'

import { SufNameEnum } from 'common/audience/audienceInterfaces'
import { UserFieldType } from 'shared/api/common/types'
import { SocketEventBaseSchema } from 'utils/services/notificationsService/constants'

const collectedInfoSchema = z.object({
  type: z.union([z.enum(SufNameEnum), z.enum(UserFieldType)]),
  field: z.string(),
  value: z.union([z.string(), z.boolean(), z.number()]),
})

const playgroundTextMessage = z.object({
  id: z.string(),
  author: z.literal('assistant'),
  ts: z.number(),
  type: z.literal('text'),
  data: z.object({
    text: z.string(),
    buttons: z.array(z.object({ url: z.string(), title: z.string() })).optional(),
    status: z.union([z.literal('ongoing'), z.literal('completed')]),
    collected_info: z.array(collectedInfoSchema),
  }),
})

export const AiAgentPlaygroundSocketEventsSchemas = {
  messageReceived: SocketEventBaseSchema.extend({
    event: z.literal('ai_agent_playground_message'),
    message: playgroundTextMessage,
    session_id: z.string(),
  }),

  playgroundFailed: SocketEventBaseSchema.extend({
    event: z.literal('ai_agent_playground_failed'),
    session_id: z.string(),
  }),
}

export type CollectedInfo = z.infer<typeof collectedInfoSchema>
export type BackendPlaygroundTextMessage = z.infer<typeof playgroundTextMessage>
